import { render, staticRenderFns } from "./SPREditTool.vue?vue&type=template&id=c01a2742"
import script from "./SPREditTool.vue?vue&type=script&lang=ts"
export * from "./SPREditTool.vue?vue&type=script&lang=ts"
import style0 from "./SPREditTool.vue?vue&type=style&index=0&id=c01a2742&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports